module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "requestcard"
  }, [_c('Small', {
    staticClass: "requestcard__create"
  }, [_vm._v(_vm._s(_vm.createDate))]), _c('MentoringMain', {
    attrs: {
      "status": _vm.statuses,
      "title": _vm.title,
      "description": _vm.description,
      "isOpened": _vm.isOpenDescription
    }
  }), _c('h4', {
    staticClass: "requestcard__status"
  }, [_vm._v("Текущий статус запроса:"), _c('span', {
    staticClass: "requestcard__span",
    class: _vm.classColor
  }, [_vm._v(" " + _vm._s(_vm.statusText))])]), _c('MentoringCardFooter', {
    attrs: {
      "text": _vm.btnText,
      "isButton": !!_vm.description.length
    },
    on: {
      "toggleDescription": _vm.toggleDescription
    }
  }, [_c('Small', {
    attrs: {
      "slot": "firstColumn"
    },
    slot: "firstColumn"
  }, [_vm._v(_vm._s(_vm.startDate))]), _c('Small', {
    attrs: {
      "slot": "secondColumn"
    },
    slot: "secondColumn"
  }, [_vm._v(_vm._s(_vm.startText))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-207f1c3c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/requestcard/MentoringRequestCard.vue
// module id = 0fb6bf1fe28ec56a4259
// module chunks = 89